// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangeAdminForm-containerWith-nPu5R {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.ChangeAdminForm-container-rv0aC {
    max-width: 100%;
}

/* Text - Start */

.ChangeAdminForm-subText-GhUrH {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.ChangeAdminForm-navigationLink-zqOBq a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.ChangeAdminForm-navigationLink-zqOBq a:hover,
.ChangeAdminForm-navigationLink-zqOBq a:focus,
.ChangeAdminForm-navigationLink-zqOBq a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.ChangeAdminForm-noPadding-zTrfZ {
    padding: 0;
}

.ChangeAdminForm-heading-h8GRi {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.ChangeAdminForm-widthInner-oqF0r {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.ChangeAdminForm-noMargin-AtKw9 {
    margin: 0;
}

.ChangeAdminForm-formControlInputTable-kw3OQ {
    border: none;
    width: 100px;
    height: auto;
}

.ChangeAdminForm-backBtn-zyAcQ {
    margin-left: 15px;
    display: inline-block;
}

.ChangeAdminForm-backBtn-zyAcQ:active,
.ChangeAdminForm-backBtn-zyAcQ:hover,
.ChangeAdminForm-backBtn-zyAcQ:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.ChangeAdminForm-textAlignRight-OVZ4v {
    text-align: right;
}

.ChangeAdminForm-displayInlineBlock-aNFux {
    display: inline-block;
}

.ChangeAdminForm-displayBlock-OX4ZZ {
    display: block;
}

.ChangeAdminForm-countryCode-GOoKI {
    width: 15%;
    vertical-align: top;
}

.ChangeAdminForm-vtrMiddle-vKSjk {
    vertical-align: middle;
}

/* commonCss */

.ChangeAdminForm-editIcon-TrveF {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.ChangeAdminForm-iconBtn-ibstM,
.ChangeAdminForm-iconBtn-ibstM:hover,
.ChangeAdminForm-iconBtn-ibstM:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.ChangeAdminForm-profileImg-GBQNt {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.ChangeAdminForm-profileImgSection-PNNMI {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.ChangeAdminForm-profileImgWidth-U0Xk8 {
    margin: 0;
    max-width: 100% !important;
}

.ChangeAdminForm-searchInput-cpXM0 {
    width: 100%;
    max-width: 320px;
}

.ChangeAdminForm-backgroundImg-f9pKu {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.ChangeAdminForm-exportDisplay-OZIcQ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.ChangeAdminForm-exportTextSection-VenCW {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.ChangeAdminForm-exportText-SdZpd {
    display: inline-block;
    padding-right: 5px;
}

.ChangeAdminForm-exportTextContainer-kfRb5 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.ChangeAdminForm-vtrTextBottom-iA7so {
    vertical-align: text-bottom;
}

.ChangeAdminForm-exportImg-gRBhn {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.ChangeAdminForm-noLink-YamvA,
.ChangeAdminForm-noLink-YamvA:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.ChangeAdminForm-singleCard-_TSoe {
    width: 500px;
    margin: 0 auto;
}

.ChangeAdminForm-defaultIcon-QyhHc {
    background-size: 50px;
}

.ChangeAdminForm-assignProviderSearchInput-htaSt {
    width: 100%;
    max-width: 324px;
}

.ChangeAdminForm-searchGroupContainer-Zrrpr {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .ChangeAdminForm-searchGroupContainer-Zrrpr {
        width: 100%;
    }

}

.ChangeAdminForm-card-LQqRc {
    border: 0;
    margin: 18px 0;
    border-radius: 0px;
    background: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    padding: 25px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.ChangeAdminForm-cardOne-AwjAn {
    border: 0;
    margin: 18px 0;
    -webkit-box-shadow: 0 6px 0 0 rgba(0, 0, 0, .01), 0 15px 32px 0 rgba(0, 0, 0, .06);
            box-shadow: 0 6px 0 0 rgba(0, 0, 0, .01), 0 15px 32px 0 rgba(0, 0, 0, .06);
    border-radius: 4px;
    background: #fff;
    padding: 25px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    border-radius: 25px;
    border-top-right-radius: 0;
    border-bottom-left-radius: 0;
}

.ChangeAdminForm-buttonWidth-kAPsl {
    width: 200px;
}

.ChangeAdminForm-fullWidth-yAWf3 {
    width: 100% !important;
}

.ChangeAdminForm-passwordSection-E6lKl {
  margin: 0 auto;
  width: 100%;
  max-width: 520px;
  background: #fff;
  border-radius: 10px;
  padding: 25px 20px;
  -webkit-box-shadow: 0 1px 15px 3px #2d3d5126;
          box-shadow: 0 1px 15px 3px #2d3d5126;
}

.ChangeAdminForm-subtext-Vsb2j {
  color: var(--secondary-foreground);
  margin: 0;
  font-size: 14px;
  margin-top: 6px;
}

.ChangeAdminForm-Section-O720s {
  max-width: 520px;
}

.ChangeAdminForm-marginNone-H1Orf{
  margin: none !important;
}

@media screen and (max-width: 767px) {
  .ChangeAdminForm-passwordSection-E6lKl {
    padding: 25px 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css","webpack://./src/components/SiteAdmin/AdminCommon.css","webpack://./src/components/SiteAdmin/ChangeAdminForm/ChangeAdminForm.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AC1OA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kFAA0E;YAA1E,0EAA0E;IAC1E,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,mBAAmB;IACnB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AC3BA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,4CAAoC;UAApC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}",".card {\n    border: 0;\n    margin: 18px 0;\n    border-radius: 0px;\n    background: #fff;\n    display: flex;\n    justify-content: space-between;\n    padding: 25px;\n    align-items: center;\n}\n\n.cardOne {\n    border: 0;\n    margin: 18px 0;\n    box-shadow: 0 6px 0 0 rgba(0, 0, 0, .01), 0 15px 32px 0 rgba(0, 0, 0, .06);\n    border-radius: 4px;\n    background: #fff;\n    padding: 25px;\n    display: flex;\n    flex-direction: column;\n    border-radius: 25px;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.buttonWidth {\n    width: 200px;\n}\n\n.fullWidth {\n    width: 100% !important;\n}","@import '../../../components/Common.css';\n@import '../AdminCommon.css';\n\n\n.passwordSection {\n  margin: 0 auto;\n  width: 100%;\n  max-width: 520px;\n  background: #fff;\n  border-radius: 10px;\n  padding: 25px 20px;\n  box-shadow: 0 1px 15px 3px #2d3d5126;\n}\n\n.subtext {\n  color: var(--secondary-foreground);\n  margin: 0;\n  font-size: 14px;\n  margin-top: 6px;\n}\n\n.Section {\n  max-width: 520px;\n}\n.marginNone{\n  margin: none !important;\n}\n\n@media screen and (max-width: 767px) {\n  .passwordSection {\n    padding: 25px 0px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `ChangeAdminForm-containerWith-nPu5R`,
	"container": `ChangeAdminForm-container-rv0aC`,
	"subText": `ChangeAdminForm-subText-GhUrH`,
	"navigationLink": `ChangeAdminForm-navigationLink-zqOBq`,
	"noPadding": `ChangeAdminForm-noPadding-zTrfZ`,
	"heading": `ChangeAdminForm-heading-h8GRi`,
	"widthInner": `ChangeAdminForm-widthInner-oqF0r`,
	"noMargin": `ChangeAdminForm-noMargin-AtKw9`,
	"formControlInputTable": `ChangeAdminForm-formControlInputTable-kw3OQ`,
	"backBtn": `ChangeAdminForm-backBtn-zyAcQ`,
	"textAlignRight": `ChangeAdminForm-textAlignRight-OVZ4v`,
	"displayInlineBlock": `ChangeAdminForm-displayInlineBlock-aNFux`,
	"displayBlock": `ChangeAdminForm-displayBlock-OX4ZZ`,
	"countryCode": `ChangeAdminForm-countryCode-GOoKI`,
	"vtrMiddle": `ChangeAdminForm-vtrMiddle-vKSjk`,
	"editIcon": `ChangeAdminForm-editIcon-TrveF`,
	"iconBtn": `ChangeAdminForm-iconBtn-ibstM`,
	"profileImg": `ChangeAdminForm-profileImg-GBQNt`,
	"profileImgSection": `ChangeAdminForm-profileImgSection-PNNMI`,
	"profileImgWidth": `ChangeAdminForm-profileImgWidth-U0Xk8`,
	"searchInput": `ChangeAdminForm-searchInput-cpXM0`,
	"backgroundImg": `ChangeAdminForm-backgroundImg-f9pKu`,
	"exportDisplay": `ChangeAdminForm-exportDisplay-OZIcQ`,
	"exportTextSection": `ChangeAdminForm-exportTextSection-VenCW`,
	"exportText": `ChangeAdminForm-exportText-SdZpd`,
	"exportTextContainer": `ChangeAdminForm-exportTextContainer-kfRb5`,
	"vtrTextBottom": `ChangeAdminForm-vtrTextBottom-iA7so`,
	"exportImg": `ChangeAdminForm-exportImg-gRBhn`,
	"noLink": `ChangeAdminForm-noLink-YamvA`,
	"singleCard": `ChangeAdminForm-singleCard-_TSoe`,
	"defaultIcon": `ChangeAdminForm-defaultIcon-QyhHc`,
	"assignProviderSearchInput": `ChangeAdminForm-assignProviderSearchInput-htaSt`,
	"searchGroupContainer": `ChangeAdminForm-searchGroupContainer-Zrrpr`,
	"card": `ChangeAdminForm-card-LQqRc`,
	"cardOne": `ChangeAdminForm-cardOne-AwjAn`,
	"buttonWidth": `ChangeAdminForm-buttonWidth-kAPsl`,
	"fullWidth": `ChangeAdminForm-fullWidth-yAWf3`,
	"passwordSection": `ChangeAdminForm-passwordSection-E6lKl`,
	"subtext": `ChangeAdminForm-subtext-Vsb2j`,
	"Section": `ChangeAdminForm-Section-O720s`,
	"marginNone": `ChangeAdminForm-marginNone-H1Orf`
};
module.exports = ___CSS_LOADER_EXPORT___;
